import axios from 'axios';
import { api } from '../config';

const apiClient = axios.create({
  baseURL: api.API_URL,
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});
export default apiClient;
